/**
 * Calculates whether the computed rgb color is light or dark to set the ideal text contrast.
 * Implements the W3C relative luminance calculation.
 *
 * @param rgbString The rgb/rgba color string (e.g., from getComputedStyle(...).backgroundColor)
 * @returns CSS variable for dark or light text based on background luminance
 */
export function calculateContrastColor(rgbString: string): string {
  const match = rgbString.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/i);

  if (!match) {
    // Safe fallback for dark default background
    return 'var(--white, #ffffff)';
  }

  const r = parseInt(match[1], 10);
  const g = parseInt(match[2], 10);
  const b = parseInt(match[3], 10);

  // W3C relative luminance calculation
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Background is light? Dark text. Background is dark? Light text.
  return luminance > 0.6
    ? 'var(--color-text-text-primary, #111827)'
    : 'var(--white, #ffffff)';
}
